import { IClientBannerImageUpload } from '@common/interfaces/client'
import Base from './base'

export interface IClientBannerPayload {
  description: string
  link?: string
  startDate: string
  endDate: string
  clientName?: string
  color?: string
  actionLabel?: string
  cancelLabel?: string
  hasPopup?: boolean
  isBeta?: boolean
  image?: IClientBannerImageUpload
  removeImage?: boolean
}

export default class ClientBanner extends Base {
  list(params: object = {}) {
    return this.apiClient.get('client-banners', params)
  }

  create(data: IClientBannerPayload) {
    return this.apiClient.post('client-banners', data)
  }

  update(id: string, data: IClientBannerPayload) {
    return this.apiClient.put(`client-banners/${id}`, data)
  }

  expire(id: string) {
    return this.apiClient.put(`client-banners/${id}/expire`)
  }

  delete(id: string) {
    return this.apiClient.delete(`client-banners/${id}`)
  }
}
